<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<crucible-dialog
  [dialogTitle]="data.exhibit.id ? 'Edit Exhibit' : 'Add Exhibit'"
  [form]="form"
  submitLabel="Save"
  [submitDisabled]="!errorFree() || !form.dirty || !data.canEdit"
  [guardUnsavedWork]="form.dirty"
  (submit)="handleEditComplete(true)"
  (cancel)="handleEditComplete(false)"
>
  @if (data && data.exhibit) {
    <div crucibleDialogContent>
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>ID</mat-label>
            <input type="text" matInput placeholder="ID" value="{{data.exhibit.id}}" disabled>
          </mat-form-field>
        </div>
      </div>
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Name</mat-label>
            <input type="text" matInput [formControl]="nameFormControl" placeholder="Name" (blur)="saveExhibit('name')"
              value="{{data.exhibit.name}}" [disabled]="!data.canEdit">
          </mat-form-field>
        </div>
      </div>
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Description</mat-label>
            <input type="text" matInput [formControl]="descriptionFormControl" placeholder="Description"
              (blur)="saveExhibit('description')" value="{{data.exhibit.description}}" [disabled]="!data.canEdit">
          </mat-form-field>
        </div>
      </div>
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Current Move</mat-label>
            <input type="text" matInput [formControl]="currentMoveFormControl" placeholder="Current Move"
              (blur)="saveExhibit('currentMove')" value="{{data.exhibit.currentMove}}" [disabled]="!data.canEdit">
            @if (currentMoveFormControl.hasError('required')) {
            <mat-error>
              Current Move is <strong>required</strong>
            </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Current Inject</mat-label>
            <input type="text" matInput [formControl]="currentInjectFormControl" placeholder="Current Inject"
              (blur)="saveExhibit('currentInject')" value="{{data.exhibit.currentInject}}" [disabled]="!data.canEdit">
            @if (currentInjectFormControl.hasError('required')) {
            <mat-error>
              Current Inject is <strong>required</strong>
            </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Scenario ID</mat-label>
            <input type="text" matInput [formControl]="exhibitIdFormControl" placeholder="Scenario ID"
              (blur)="saveExhibit('scenarioId')" value="{{data.exhibit.scenarioId}}" [disabled]="!data.canEdit">
          </mat-form-field>
        </div>
      </div>
      <div class="add-margin">
        <mat-checkbox [formControl]="showAdvanceButtonFormControl" [disabled]="!data.canEdit">
          Show Advance Button
        </mat-checkbox>
      </div>
    </div>
  }
</crucible-dialog>
